<div class="visualizer">
  @for (element of visualElements; track element) {
    <div class="sound-bar" [ngStyle]="element"></div>
  }
</div>